import { Component, ElementRef, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { registerables } from 'chart.js';
import Chart from 'chart.js/auto';
import zoomPlugin from 'chartjs-plugin-zoom';
import axios from 'src/app/Service/axios';

@Component({
  selector: 'app-ecu-chart',
  templateUrl: './ecu-chart.component.html',
  styleUrls: ['./ecu-chart.component.css']
})

export class EcuChartComponent implements OnInit {
  parentSection: 'basic-info' | 'full-info';
  obj: any;
  ctx1: any;
  label: Array<any> = [];
  datachart: Array<any> = [];
  CHART_COLORS: any = {
    green: 'rgb(111, 255, 111)',
    purple: 'rgb(255, 153, 204)',
    blue: 'rgb(29, 179, 214)',
    orange: 'rgb(45, 103, 103)',
    yellow: 'rgb(251, 101, 150)',
    red: 'rgb(36, 123, 46)',
    grey: 'rgb(103, 13, 183)',
  };

  mdl_Search: FormGroup = this.formBuilder.group({
    iSystemUser: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('ID')!)),
    strSession: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('Session')!)),
    strUnitID: new FormControl(),
    iOBD2_Code: new FormControl(),
    iOBD2_Log: new FormControl(),
    title: new FormControl(),
    strEnglishName: new FormControl(),
    iCAN_LatestState: new FormControl(),
  });

  constructor(

    private el: ElementRef,

    private _tooltip: NotificationService,

    private router: Router,

    public _otherService: OtherService,

    private route: ActivatedRoute,

    private formBuilder: FormBuilder,

    private gurdService: GurdServiceService,

  ) {
    Chart.register(...registerables);

    Chart.register(zoomPlugin);

  }

  ngOnInit(): void {

    const id = this.route.parent?.parent?.snapshot.params['id'];
    const iobd = this.route?.snapshot?.params['iobd'];
    this.parentSection = this.route.snapshot.data?.parentSection;

    if (this.parentSection == 'basic-info') {
      this.mdl_Search.patchValue({
        strUnitID: id,
        iOBD2_Code: iobd,
        iOBD2_Log: id,
        strEnglishName: ''
      });

      this.initChart();

    }

    else if (this.parentSection == 'full-info') {
      this.mdl_Search.patchValue({
        strUnitID: id,
        strEnglishName: '',
        iCAN_LatestState: iobd,
        iOBD2_Code: '',
        iOBD2_Log: '',
      });

      this.initChart();

    }

    // this.initFakeData();

  }

  async initChart() {

    this.mdl_Search.patchValue({

      title: this.gurdService.decrypt(localStorage.getItem('Ecu_title')!)

    })

    this._otherService.Showspinner();

    const ENDPOINT = this.parentSection == 'basic-info' ? 'OBD2_CodeChart' : 'CAN_CodeChart';

    let res = JSON.parse((await axios.post(ENDPOINT, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._otherService.nonespinner();

    if (res.ISSessionExpired == true) {

      this._otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: '1xxA4' } });

      return;

    }

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.drawChart(res);

  }

  initFakeData() {

    const fakeEcuData = [
      { X: 1000, Y: 20 },
      { X: 1500, Y: 25 },
      { X: 2000, Y: 32 },
      { X: 2500, Y: 45 },
      { X: 3000, Y: 52 },
      { X: 3500, Y: 48 },
      { X: 4000, Y: 60 },
      { X: 4500, Y: 72 },
      { X: 5000, Y: 65 },
      { X: 5500, Y: 58 },
      { X: 6000, Y: 50 }
    ];

    this.drawChart(fakeEcuData);

  }

  drawChart(resParse) {

    this.obj = resParse;

    this.label = [];
    this.datachart = [];

    this.obj.forEach((element: any) => {
      this.label.push(element.X);
      this.datachart.push(element.Y);
    });

    const ctx = document.getElementById('myChart') as any;

    if (this.ctx1) {
      this.ctx1.destroy();
    }

    this.ctx1 = new Chart(ctx, {

      type: 'line',

      data: {
        labels: this.label,
        datasets: [
          {
            data: this.datachart,
            borderColor: '#00ffff',
            backgroundColor: '#00ffff10',
            fill: true,
            tension: 0.4,

            pointBackgroundColor: '#00ffff',
            pointBorderColor: '#00ffff',
            pointRadius: 3
          }
        ],
      },

      options: {

        responsive: true,

        interaction: {
          mode: 'nearest',
          intersect: false
        },

        plugins: {

          legend: {
            display: false
          },

          tooltip: {
            enabled: true,

            backgroundColor: '#0b0f14',
            borderColor: '#00ffff',
            borderWidth: 1,

            titleColor: '#00ffff',
            bodyColor: '#ffffff',

            titleFont: {
              family: 'bYekan',
              size: 13
            },

            bodyFont: {
              family: 'bYekan',
              size: 12
            },

            padding: 10,
            displayColors: false,

            callbacks: {
              label: (context) => {
                return `مقدار: ${context.parsed.y}`;
              }
            }
          },

          zoom: {
            zoom: {
              wheel: { enabled: true },
              pinch: { enabled: true },
              mode: 'x'
            }
          }
        },

        scales: {

          x: {
            ticks: {
              color: '#ffffffa9',
              font: {
                family: 'bYekan',
                size: 12
              }
            },
            grid: {
              color: '#ffffff10',
              borderColor: '#ffffff60',
              borderWidth: 1
            }
          },

          y: {
            ticks: {
              color: '#ffffffa9',
              font: {
                family: 'bYekan',
                size: 12
              }
            },
            grid: {
              color: '#ffffff10',
              borderColor: '#ffffff60',
              borderWidth: 1
            }
          }
        }
      }
    });
  }

}
